import { __assign, __values } from "tslib";
import { parse, Kind, isSchema, isDefinitionNode, } from 'graphql';
import { defaultStringComparator, isSourceTypes, isStringTypes } from './utils';
import { mergeGraphQLNodes, schemaDefSymbol } from './merge-nodes';
import { resetComments, printWithComments } from './comments';
import { getDocumentNodeFromSchema } from '@graphql-tools/utils';
import { operationTypeDefinitionNodeTypeRootTypeMap } from './schema-def';
export function mergeTypeDefs(types, config) {
    resetComments();
    var doc = {
        kind: Kind.DOCUMENT,
        definitions: mergeGraphQLTypes(types, __assign({ useSchemaDefinition: true, forceSchemaDefinition: false, throwOnConflict: false, commentDescriptions: false }, config)),
    };
    var result;
    if (config && config.commentDescriptions) {
        result = printWithComments(doc);
    }
    else {
        result = doc;
    }
    resetComments();
    return result;
}
function visitTypeSources(types, allNodes) {
    var e_1, _a;
    try {
        for (var types_1 = __values(types), types_1_1 = types_1.next(); !types_1_1.done; types_1_1 = types_1.next()) {
            var type = types_1_1.value;
            if (type) {
                if (Array.isArray(type)) {
                    visitTypeSources(type, allNodes);
                }
                else if (isSchema(type)) {
                    var documentNode = getDocumentNodeFromSchema(type);
                    visitTypeSources(documentNode.definitions, allNodes);
                }
                else if (isStringTypes(type) || isSourceTypes(type)) {
                    var documentNode = parse(type);
                    visitTypeSources(documentNode.definitions, allNodes);
                }
                else if (isDefinitionNode(type)) {
                    allNodes.push(type);
                }
                else {
                    visitTypeSources(type.definitions, allNodes);
                }
            }
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (types_1_1 && !types_1_1.done && (_a = types_1.return)) _a.call(types_1);
        }
        finally { if (e_1) throw e_1.error; }
    }
}
export function mergeGraphQLTypes(types, config) {
    var _a, _b;
    resetComments();
    var allNodes = [];
    visitTypeSources(types, allNodes);
    var mergedNodes = mergeGraphQLNodes(allNodes, config);
    // XXX: right now we don't handle multiple schema definitions
    var schemaDef = mergedNodes[schemaDefSymbol] || {
        kind: Kind.SCHEMA_DEFINITION,
        operationTypes: [],
    };
    if (config === null || config === void 0 ? void 0 : config.useSchemaDefinition) {
        var operationTypes = schemaDef.operationTypes;
        var _loop_1 = function (opTypeDefNodeType) {
            var opTypeDefNode = operationTypes.find(function (operationType) { return operationType.operation === opTypeDefNodeType; });
            if (!opTypeDefNode) {
                var existingPossibleRootType = mergedNodes[operationTypeDefinitionNodeTypeRootTypeMap[opTypeDefNodeType]];
                if (existingPossibleRootType) {
                    operationTypes.push({
                        kind: Kind.OPERATION_TYPE_DEFINITION,
                        type: {
                            kind: Kind.NAMED_TYPE,
                            name: existingPossibleRootType.name,
                        },
                        operation: opTypeDefNodeType,
                    });
                }
            }
        };
        for (var opTypeDefNodeType in operationTypeDefinitionNodeTypeRootTypeMap) {
            _loop_1(opTypeDefNodeType);
        }
    }
    if ((config === null || config === void 0 ? void 0 : config.forceSchemaDefinition) && !((_a = schemaDef === null || schemaDef === void 0 ? void 0 : schemaDef.operationTypes) === null || _a === void 0 ? void 0 : _a.length)) {
        schemaDef = {
            kind: Kind.SCHEMA_DEFINITION,
            operationTypes: [
                {
                    kind: Kind.OPERATION_TYPE_DEFINITION,
                    operation: 'query',
                    type: {
                        kind: Kind.NAMED_TYPE,
                        name: {
                            kind: Kind.NAME,
                            value: 'Query',
                        },
                    },
                },
            ],
        };
    }
    var mergedNodeDefinitions = Object.values(mergedNodes);
    if ((_b = schemaDef.operationTypes) === null || _b === void 0 ? void 0 : _b.length) {
        mergedNodeDefinitions.push(schemaDef);
    }
    if (config === null || config === void 0 ? void 0 : config.sort) {
        var sortFn_1 = typeof config.sort === 'function' ? config.sort : defaultStringComparator;
        mergedNodeDefinitions.sort(function (a, b) { var _a, _b; return sortFn_1((_a = a.name) === null || _a === void 0 ? void 0 : _a.value, (_b = b.name) === null || _b === void 0 ? void 0 : _b.value); });
    }
    return mergedNodeDefinitions;
}
//# sourceMappingURL=merge-typedefs.js.map